define("settings/templates/overview", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f

  var _default = (0, _templateFactory.createTemplateFactory)(
  /*
    <MigrationBanner />
  {{#if (user-agent "device.isMobile")}}
    <Shared::Ui::FeatureHeader @showMobileMenu={{true}} @title={{t "account.navigation.Header"}} />
    <div class="o--page__notice u--p__t">
      <AddressBanner />
    </div>
    <Shared::PlatformNotice />
  {{/if}}
  
  <Shared::Card class="tAC--card" as |card|>
    <card.header @title={{t "account.overview.title"}} @titleClass="tAC--header__title" />
    <card.body>
  
      <Section
        @title={{t "account.overview.subscription_overview.title"}}
        class="qa--settings__section--subscription tAc--section__full"
      >
        {{! Subscription Details }}
        <SubscriptionOverview
          @canShowCancelTrial={{true}}
          @currentPage="account-settings"
          class="qa--settings__subSection--manage"
        />
  
        {{#if this.hasCancelledSubscription}}
          <hr class="tAC--section__divider" />
          <CancelledPlanOverview />
        {{/if}}
      </Section>
  
      {{#if this.hasSubscription}}
        <Section
          @title={{t "account.overview.subscription_manager.manage_title"}}
          class="qa--settings__section--manageSubscription u--m__t__lg u--m__b__md u--hide--mobile"
        >
          {{! Subscription Manager }}
          <div class="u--clearfix">
            <p class="u--text--md u--float--left u--m__t__xs u--m__b__0">
              {{#if (or this.hasCancelledSubscription this.hasUpcomingDowngrade)}}
                <span class="u--text--strike">
                  {{this.subscriptionPlan.displayName}}
                </span>
                {{#if this.hasUpcomingDowngrade}}
                  {{this.upcomingSubscriptionPlan.displayName}}
                {{else}}
                  {{t "account.subscription.index.manage_plan.free"}}
                {{/if}}
              {{else}}
                {{this.subscriptionPlan.displayName}}
              {{/if}}
            </p>
            <div class="tAC--section__action u--float--right">
              <LinkTo @route="subscription" class="o--btn o--btn--outline u--m__r" {{on "mouseenter" this.loadPayments}}>
                {{t "account.overview.subscription_overview.manage"}}
              </LinkTo>
            </div>
          </div>
  
          <hr class="tAC--section__divider u--m__b__lg" />
  
        </Section>
      {{/if}}
  
      <Section class="qa--settings__section--subscription u--hide--mobile" as |section|>
        {{! Social Profile Post Count }}
        <section.wrapper>
          <MonthlyPostUsage @socialProfiles={{this.socialProfiles}} class="qa--settings__subSection--usage" />
        </section.wrapper>
      </Section>
      {{#if this.canAiCredits}}
        <Section as |section|>
          {{! Credit Count }}
          <section.wrapper>
            <CreditUsage />
          </section.wrapper>
        </Section>
      {{/if}}
  
      <Section
        @title={{t "account.overview.basic_information.title"}}
        class="qa--settings__section--personalInformation"
        as |section|
      >
  
        {{! Name }}
        <section.wrapper class="qa--settings__subSection--name u--hide--mf">
          <section.details
            @description={{this.user.name}}
            @descriptionStyles="u--text--md"
            @title={{t "shared_words.name"}}
            @titleStyles="u--text--sm u--text--bold"
          />
          <section.action
            @buttonRoute="overview.edit"
            @buttonStyles="qa--settings__button--edit"
            @buttonText={{t "shared_words.edit"}}
          />
        </section.wrapper>
  
        {{! Email }}
        <section.wrapper class="qa--settings__subSection--email u--hide--mf">
          <section.details
            @description={{this.user.email}}
            @descriptionStyles="u--text--md"
            @title={{t "shared_words.email"}}
            @titleStyles="u--text--sm u--text--bold"
          />
          <section.action
            @buttonRoute="overview.edit"
            @buttonStyles="qa--settings__button--edit"
            @buttonText={{t "shared_words.edit"}}
          />
        </section.wrapper>
  
        {{! Change Password }}
        <section.wrapper class="qa--settings__subSection--password">
          <section.details @title={{t "shared_phrases.change_password"}} @titleStyles="u--text--md" />
          <section.action
            @buttonRoute="overview.password"
            @buttonStyles="qa--settings__button--update"
            @buttonText={{t "shared_words.update"}}
          />
        </section.wrapper>
  
      </Section>
  
      <Section
        @title={{t "account.overview.preferences.title"}}
        class="qa--settings__section--preferences u--hide--mobile"
        as |section|
      >
  
        {{! Timezone }}
        <section.wrapper class="qa--settings__subSection--timeZone">
          <section.details
            @description={{this.user.timeZone}}
            @descriptionStyles="u--text--md"
            @title={{t "account.overview.preferences.timezone"}}
            @titleStyles="u--text--sm u--text--bold"
          />
          <section.action
            @buttonRoute="overview.preferences"
            @buttonStyles="qa--settings__button--edit"
            @buttonText={{t "shared_words.edit"}}
          />
        </section.wrapper>
  
        {{! First Day of the Week }}
        <section.wrapper class="qa--settings__subSection--startingDay">
          <section.details
            @description={{this.firstDayWeek}}
            @descriptionStyles="u--text--md"
            @title={{t "account.overview.preferences.first_day_of_week"}}
            @titleStyles="u--text--sm u--text--bold"
          />
          <section.action
            @buttonRoute="overview.preferences"
            @buttonStyles="qa--settings__button--edit"
            @buttonText={{t "shared_words.edit"}}
          />
        </section.wrapper>
  
      </Section>
  
      <Section
        @title={{t "account.overview.display.title"}}
        class="qa--settings__section--display u--hide--mobile"
        as |section|
      >
        {{! Language}}
        <section.wrapper class="qa--settings__subSection--language">
          <section.details @description={{this.locale.userLocaleName}} @descriptionStyles="u--text--md">
            <:title>
              <span>
                <span class="u--text--sm u--text--bold">{{t "account.overview.display.language"}}</span>
                <Shared::Badge @className="cVL--badge--sm is--beta" />
              </span>
            </:title>
          </section.details>
  
          <section.action
            @buttonRoute="overview.display"
            @buttonStyles="qa--settings__button--edit"
            @buttonText={{t "shared_words.edit"}}
          />
        </section.wrapper>
      </Section>
  
      {{#if this.canEnableTwoFactor}}
        <Section
          @title={{t "account.two_factor.settings_title"}}
          class="qa--settings__section--security u--hide--mobile"
          as |section|
        >
          <section.wrapper class="qa--settings__subSection--startingDay">
            <section.details
              @description={{t "account.overview.preferences.two_factor.title"}}
              @descriptionStyles="u--text--md"
              @titleStyles="u--text--sm u--text--bold"
            />
            <section.action>
              <button
                class="o--btn o--btn--outline u--m__r qa--settings__button--enableAll"
                onclick={{perform this.toggleTwoFactor}}
                type="button"
              >
                {{t
                  (concat
                    "account.overview.preferences.two_factor."
                    (if this.auth.currentUserModel.otp_required_for_login "disable_button" "enable_button")
                  )
                }}
              </button>
            </section.action>
          </section.wrapper>
        </Section>
      {{/if}}
  
      {{#if (and this.user.isAccountOwner this.account.canAnalyticsEmail)}}
        {{! Section: Weekly Analytics Report }}
        <Section class="qa--settings__section--analytics u--hide--mobile" as |section|>
  
          <section.wrapper>
            <section.details
              @description={{t "account.overview.analytics_emails.description"}}
              @title={{t "account.overview.analytics_emails.title"}}
              @titleStyles="tAC--section__title u--m__b__xs u--text--bold"
            />
            <section.action>
              {{#if this.instagramProfiles.length}}
                <button
                  class="o--btn o--btn--outline u--m__r qa--settings__button--enableAll"
                  onclick={{perform this.handleAllAnalyticsEmailsToggle this.instagramProfiles this.allAnalyticsEmails}}
                  type="button"
                >
                  {{t
                    (concat
                      "account.overview.analytics_emails."
                      (if this.allAnalyticsEmails "disable_all_button" "enable_all_button")
                    )
                  }}
                </button>
              {{/if}}
            </section.action>
          </section.wrapper>
  
          {{#each this.instagramProfiles as |instagramProfile|}}
            {{! Social Profile Switch }}
            <section.wrapper class="qa--settings__subSection--account">
              <section.details>
                <Shared::ProfileAvatar @showDetails={{true}} @showPlatform={{true}} @socialProfile={{instagramProfile}} />
              </section.details>
              <section.action>
                <Shared::Ui::CheckboxSwitch
                  @isDisabled={{false}}
                  @propertyToggled={{instagramProfile.analyticsEmail}}
                  @toggleAction={{action (perform this.handleAnalyticsEmailToggle instagramProfile)}}
                  class="qa--settings__toggle"
                />
              </section.action>
            </section.wrapper>
          {{else}}
            <div class="o--blank">
              <h2 class="o--blank__title">
                {{t "account.overview.analytics_emails.empty.title"}}
              </h2>
              <p class="o--blank__desc">
                {{t "account.overview.analytics_emails.empty.desc"}}
              </p>
            </div>
          {{/each}}
  
        </Section>
      {{/if}}
  
      {{! Section: Leave Later }}
      <Section
        @title={{t "account.overview.leave_later.title"}}
        @titleStyles="u--text--danger"
        class="qa--settings__section--leave u--hide--mobile"
        as |section|
      >
  
        <section.wrapper class="qa--settings__subSection--delete">
          <section.details @title={{this.leaveLaterDescription}} @titleStyles="u--text--danger u--text--md" />
          <section.action>
            <LinkTo
              @disabled={{this.isMobileSubscription}}
              @route="overview.leave"
              class="o--btn o--btn--mute qa--settings_button--delete {{if this.isMobileSubscription 'o--btn--disabled'}}"
            >
              {{t "account.overview.leave_later.button"}}
            </LinkTo>
          </section.action>
        </section.wrapper>
  
      </Section>
  
      {{#if (and (user-agent "device.isMobile") (not this.isMobileSubscription))}}
        <BillingSection />
      {{/if}}
  
    </card.body>
  </Shared::Card>
  
  {{#if (user-agent "device.isMobile")}}
    <Shared::Ui::button
      @additional="block"
      @class="u--m__b__lg"
      @onClick={{this.logout}}
      @size="large"
      @text={{t "shared_words.logout"}}
      @variant="outline"
    />
  {{/if}}
  
  {{outlet}}
  */
  {
    "id": "r14vIrUZ",
    "block": "[[[8,[39,0],null,null,null],[1,\"\\n\"],[41,[28,[37,2],[\"device.isMobile\"],null],[[[1,\"  \"],[8,[39,3],null,[[\"@showMobileMenu\",\"@title\"],[true,[28,[37,4],[\"account.navigation.Header\"],null]]],null],[1,\"\\n  \"],[10,0],[14,0,\"o--page__notice u--p__t\"],[12],[1,\"\\n    \"],[8,[39,5],null,null,null],[1,\"\\n  \"],[13],[1,\"\\n  \"],[8,[39,6],null,null,null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[8,[39,7],[[24,0,\"tAC--card\"]],null,[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"header\"]],null,[[\"@title\",\"@titleClass\"],[[28,[37,4],[\"account.overview.title\"],null],\"tAC--header__title\"]],null],[1,\"\\n  \"],[8,[30,1,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n\\n    \"],[8,[39,8],[[24,0,\"qa--settings__section--subscription tAc--section__full\"]],[[\"@title\"],[[28,[37,4],[\"account.overview.subscription_overview.title\"],null]]],[[\"default\"],[[[[1,\"\\n\"],[1,\"      \"],[8,[39,9],[[24,0,\"qa--settings__subSection--manage\"]],[[\"@canShowCancelTrial\",\"@currentPage\"],[true,\"account-settings\"]],null],[1,\"\\n\\n\"],[41,[30,0,[\"hasCancelledSubscription\"]],[[[1,\"        \"],[10,\"hr\"],[14,0,\"tAC--section__divider\"],[12],[13],[1,\"\\n        \"],[8,[39,10],null,null,null],[1,\"\\n\"]],[]],null],[1,\"    \"]],[]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"hasSubscription\"]],[[[1,\"      \"],[8,[39,8],[[24,0,\"qa--settings__section--manageSubscription u--m__t__lg u--m__b__md u--hide--mobile\"]],[[\"@title\"],[[28,[37,4],[\"account.overview.subscription_manager.manage_title\"],null]]],[[\"default\"],[[[[1,\"\\n\"],[1,\"        \"],[10,0],[14,0,\"u--clearfix\"],[12],[1,\"\\n          \"],[10,2],[14,0,\"u--text--md u--float--left u--m__t__xs u--m__b__0\"],[12],[1,\"\\n\"],[41,[28,[37,11],[[30,0,[\"hasCancelledSubscription\"]],[30,0,[\"hasUpcomingDowngrade\"]]],null],[[[1,\"              \"],[10,1],[14,0,\"u--text--strike\"],[12],[1,\"\\n                \"],[1,[30,0,[\"subscriptionPlan\",\"displayName\"]]],[1,\"\\n              \"],[13],[1,\"\\n\"],[41,[30,0,[\"hasUpcomingDowngrade\"]],[[[1,\"                \"],[1,[30,0,[\"upcomingSubscriptionPlan\",\"displayName\"]]],[1,\"\\n\"]],[]],[[[1,\"                \"],[1,[28,[35,4],[\"account.subscription.index.manage_plan.free\"],null]],[1,\"\\n\"]],[]]]],[]],[[[1,\"              \"],[1,[30,0,[\"subscriptionPlan\",\"displayName\"]]],[1,\"\\n\"]],[]]],[1,\"          \"],[13],[1,\"\\n          \"],[10,0],[14,0,\"tAC--section__action u--float--right\"],[12],[1,\"\\n            \"],[8,[39,12],[[24,0,\"o--btn o--btn--outline u--m__r\"],[4,[38,13],[\"mouseenter\",[30,0,[\"loadPayments\"]]],null]],[[\"@route\"],[\"subscription\"]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,4],[\"account.overview.subscription_overview.manage\"],null]],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\\n        \"],[10,\"hr\"],[14,0,\"tAC--section__divider u--m__b__lg\"],[12],[13],[1,\"\\n\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[8,[39,8],[[24,0,\"qa--settings__section--subscription u--hide--mobile\"]],null,[[\"default\"],[[[[1,\"\\n\"],[1,\"      \"],[8,[30,2,[\"wrapper\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[39,14],[[24,0,\"qa--settings__subSection--usage\"]],[[\"@socialProfiles\"],[[30,0,[\"socialProfiles\"]]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[2]]]]],[1,\"\\n\"],[41,[30,0,[\"canAiCredits\"]],[[[1,\"      \"],[8,[39,8],null,null,[[\"default\"],[[[[1,\"\\n\"],[1,\"        \"],[8,[30,3,[\"wrapper\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[8,[39,15],null,null,null],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"]],[3]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[8,[39,8],[[24,0,\"qa--settings__section--personalInformation\"]],[[\"@title\"],[[28,[37,4],[\"account.overview.basic_information.title\"],null]]],[[\"default\"],[[[[1,\"\\n\\n\"],[1,\"      \"],[8,[30,4,[\"wrapper\"]],[[24,0,\"qa--settings__subSection--name u--hide--mf\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,4,[\"details\"]],null,[[\"@description\",\"@descriptionStyles\",\"@title\",\"@titleStyles\"],[[30,0,[\"user\",\"name\"]],\"u--text--md\",[28,[37,4],[\"shared_words.name\"],null],\"u--text--sm u--text--bold\"]],null],[1,\"\\n        \"],[8,[30,4,[\"action\"]],null,[[\"@buttonRoute\",\"@buttonStyles\",\"@buttonText\"],[\"overview.edit\",\"qa--settings__button--edit\",[28,[37,4],[\"shared_words.edit\"],null]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n\\n\"],[1,\"      \"],[8,[30,4,[\"wrapper\"]],[[24,0,\"qa--settings__subSection--email u--hide--mf\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,4,[\"details\"]],null,[[\"@description\",\"@descriptionStyles\",\"@title\",\"@titleStyles\"],[[30,0,[\"user\",\"email\"]],\"u--text--md\",[28,[37,4],[\"shared_words.email\"],null],\"u--text--sm u--text--bold\"]],null],[1,\"\\n        \"],[8,[30,4,[\"action\"]],null,[[\"@buttonRoute\",\"@buttonStyles\",\"@buttonText\"],[\"overview.edit\",\"qa--settings__button--edit\",[28,[37,4],[\"shared_words.edit\"],null]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n\\n\"],[1,\"      \"],[8,[30,4,[\"wrapper\"]],[[24,0,\"qa--settings__subSection--password\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,4,[\"details\"]],null,[[\"@title\",\"@titleStyles\"],[[28,[37,4],[\"shared_phrases.change_password\"],null],\"u--text--md\"]],null],[1,\"\\n        \"],[8,[30,4,[\"action\"]],null,[[\"@buttonRoute\",\"@buttonStyles\",\"@buttonText\"],[\"overview.password\",\"qa--settings__button--update\",[28,[37,4],[\"shared_words.update\"],null]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n\\n    \"]],[4]]]]],[1,\"\\n\\n    \"],[8,[39,8],[[24,0,\"qa--settings__section--preferences u--hide--mobile\"]],[[\"@title\"],[[28,[37,4],[\"account.overview.preferences.title\"],null]]],[[\"default\"],[[[[1,\"\\n\\n\"],[1,\"      \"],[8,[30,5,[\"wrapper\"]],[[24,0,\"qa--settings__subSection--timeZone\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,5,[\"details\"]],null,[[\"@description\",\"@descriptionStyles\",\"@title\",\"@titleStyles\"],[[30,0,[\"user\",\"timeZone\"]],\"u--text--md\",[28,[37,4],[\"account.overview.preferences.timezone\"],null],\"u--text--sm u--text--bold\"]],null],[1,\"\\n        \"],[8,[30,5,[\"action\"]],null,[[\"@buttonRoute\",\"@buttonStyles\",\"@buttonText\"],[\"overview.preferences\",\"qa--settings__button--edit\",[28,[37,4],[\"shared_words.edit\"],null]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n\\n\"],[1,\"      \"],[8,[30,5,[\"wrapper\"]],[[24,0,\"qa--settings__subSection--startingDay\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,5,[\"details\"]],null,[[\"@description\",\"@descriptionStyles\",\"@title\",\"@titleStyles\"],[[30,0,[\"firstDayWeek\"]],\"u--text--md\",[28,[37,4],[\"account.overview.preferences.first_day_of_week\"],null],\"u--text--sm u--text--bold\"]],null],[1,\"\\n        \"],[8,[30,5,[\"action\"]],null,[[\"@buttonRoute\",\"@buttonStyles\",\"@buttonText\"],[\"overview.preferences\",\"qa--settings__button--edit\",[28,[37,4],[\"shared_words.edit\"],null]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n\\n    \"]],[5]]]]],[1,\"\\n\\n    \"],[8,[39,8],[[24,0,\"qa--settings__section--display u--hide--mobile\"]],[[\"@title\"],[[28,[37,4],[\"account.overview.display.title\"],null]]],[[\"default\"],[[[[1,\"\\n\"],[1,\"      \"],[8,[30,6,[\"wrapper\"]],[[24,0,\"qa--settings__subSection--language\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,6,[\"details\"]],null,[[\"@description\",\"@descriptionStyles\"],[[30,0,[\"locale\",\"userLocaleName\"]],\"u--text--md\"]],[[\"title\"],[[[[1,\"\\n            \"],[10,1],[12],[1,\"\\n              \"],[10,1],[14,0,\"u--text--sm u--text--bold\"],[12],[1,[28,[35,4],[\"account.overview.display.language\"],null]],[13],[1,\"\\n              \"],[8,[39,16],null,[[\"@className\"],[\"cVL--badge--sm is--beta\"]],null],[1,\"\\n            \"],[13],[1,\"\\n          \"]],[]]]]],[1,\"\\n\\n        \"],[8,[30,6,[\"action\"]],null,[[\"@buttonRoute\",\"@buttonStyles\",\"@buttonText\"],[\"overview.display\",\"qa--settings__button--edit\",[28,[37,4],[\"shared_words.edit\"],null]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[6]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"canEnableTwoFactor\"]],[[[1,\"      \"],[8,[39,8],[[24,0,\"qa--settings__section--security u--hide--mobile\"]],[[\"@title\"],[[28,[37,4],[\"account.two_factor.settings_title\"],null]]],[[\"default\"],[[[[1,\"\\n        \"],[8,[30,7,[\"wrapper\"]],[[24,0,\"qa--settings__subSection--startingDay\"]],null,[[\"default\"],[[[[1,\"\\n          \"],[8,[30,7,[\"details\"]],null,[[\"@description\",\"@descriptionStyles\",\"@titleStyles\"],[[28,[37,4],[\"account.overview.preferences.two_factor.title\"],null],\"u--text--md\",\"u--text--sm u--text--bold\"]],null],[1,\"\\n          \"],[8,[30,7,[\"action\"]],null,null,[[\"default\"],[[[[1,\"\\n            \"],[10,\"button\"],[14,0,\"o--btn o--btn--outline u--m__r qa--settings__button--enableAll\"],[15,\"onclick\",[28,[37,17],[[30,0,[\"toggleTwoFactor\"]]],null]],[14,4,\"button\"],[12],[1,\"\\n              \"],[1,[28,[35,4],[[28,[37,18],[\"account.overview.preferences.two_factor.\",[52,[30,0,[\"auth\",\"currentUserModel\",\"otp_required_for_login\"]],\"disable_button\",\"enable_button\"]],null]],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"]],[7]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,19],[[30,0,[\"user\",\"isAccountOwner\"]],[30,0,[\"account\",\"canAnalyticsEmail\"]]],null],[[[1,\"      \"],[8,[39,8],[[24,0,\"qa--settings__section--analytics u--hide--mobile\"]],null,[[\"default\"],[[[[1,\"\\n\\n        \"],[8,[30,8,[\"wrapper\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[8,[30,8,[\"details\"]],null,[[\"@description\",\"@title\",\"@titleStyles\"],[[28,[37,4],[\"account.overview.analytics_emails.description\"],null],[28,[37,4],[\"account.overview.analytics_emails.title\"],null],\"tAC--section__title u--m__b__xs u--text--bold\"]],null],[1,\"\\n          \"],[8,[30,8,[\"action\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"instagramProfiles\",\"length\"]],[[[1,\"              \"],[10,\"button\"],[14,0,\"o--btn o--btn--outline u--m__r qa--settings__button--enableAll\"],[15,\"onclick\",[28,[37,17],[[30,0,[\"handleAllAnalyticsEmailsToggle\"]],[30,0,[\"instagramProfiles\"]],[30,0,[\"allAnalyticsEmails\"]]],null]],[14,4,\"button\"],[12],[1,\"\\n                \"],[1,[28,[35,4],[[28,[37,18],[\"account.overview.analytics_emails.\",[52,[30,0,[\"allAnalyticsEmails\"]],\"disable_all_button\",\"enable_all_button\"]],null]],null]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"]],[]]]]],[1,\"\\n        \"]],[]]]]],[1,\"\\n\\n\"],[42,[28,[37,21],[[28,[37,21],[[30,0,[\"instagramProfiles\"]]],null]],null],null,[[[1,\"          \"],[8,[30,8,[\"wrapper\"]],[[24,0,\"qa--settings__subSection--account\"]],null,[[\"default\"],[[[[1,\"\\n            \"],[8,[30,8,[\"details\"]],null,null,[[\"default\"],[[[[1,\"\\n              \"],[8,[39,22],null,[[\"@showDetails\",\"@showPlatform\",\"@socialProfile\"],[true,true,[30,9]]],null],[1,\"\\n            \"]],[]]]]],[1,\"\\n            \"],[8,[30,8,[\"action\"]],null,null,[[\"default\"],[[[[1,\"\\n              \"],[8,[39,23],[[24,0,\"qa--settings__toggle\"]],[[\"@isDisabled\",\"@propertyToggled\",\"@toggleAction\"],[false,[30,9,[\"analyticsEmail\"]],[28,[37,24],[[30,0],[28,[37,17],[[30,0,[\"handleAnalyticsEmailToggle\"]],[30,9]],null]],null]]],null],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"]],[]]]]],[1,\"\\n\"]],[9]],[[[1,\"          \"],[10,0],[14,0,\"o--blank\"],[12],[1,\"\\n            \"],[10,\"h2\"],[14,0,\"o--blank__title\"],[12],[1,\"\\n              \"],[1,[28,[35,4],[\"account.overview.analytics_emails.empty.title\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,2],[14,0,\"o--blank__desc\"],[12],[1,\"\\n              \"],[1,[28,[35,4],[\"account.overview.analytics_emails.empty.desc\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]],[1,\"\\n      \"]],[8]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[1,\"    \"],[8,[39,8],[[24,0,\"qa--settings__section--leave u--hide--mobile\"]],[[\"@title\",\"@titleStyles\"],[[28,[37,4],[\"account.overview.leave_later.title\"],null],\"u--text--danger\"]],[[\"default\"],[[[[1,\"\\n\\n      \"],[8,[30,10,[\"wrapper\"]],[[24,0,\"qa--settings__subSection--delete\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,10,[\"details\"]],null,[[\"@title\",\"@titleStyles\"],[[30,0,[\"leaveLaterDescription\"]],\"u--text--danger u--text--md\"]],null],[1,\"\\n        \"],[8,[30,10,[\"action\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[8,[39,12],[[16,0,[29,[\"o--btn o--btn--mute qa--settings_button--delete \",[52,[30,0,[\"isMobileSubscription\"]],\"o--btn--disabled\"]]]]],[[\"@disabled\",\"@route\"],[[30,0,[\"isMobileSubscription\"]],\"overview.leave\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,4],[\"account.overview.leave_later.button\"],null]],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n\\n    \"]],[10]]]]],[1,\"\\n\\n\"],[41,[28,[37,19],[[28,[37,2],[\"device.isMobile\"],null],[28,[37,25],[[30,0,[\"isMobileSubscription\"]]],null]],null],[[[1,\"      \"],[8,[39,26],null,null,null],[1,\"\\n\"]],[]],null],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]],[1,\"\\n\\n\"],[41,[28,[37,2],[\"device.isMobile\"],null],[[[1,\"  \"],[8,[39,27],null,[[\"@additional\",\"@class\",\"@onClick\",\"@size\",\"@text\",\"@variant\"],[\"block\",\"u--m__b__lg\",[30,0,[\"logout\"]],\"large\",[28,[37,4],[\"shared_words.logout\"],null],\"outline\"]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[46,[28,[37,29],null,null],null,null,null]],[\"card\",\"section\",\"section\",\"section\",\"section\",\"section\",\"section\",\"section\",\"instagramProfile\",\"section\"],false,[\"migration-banner\",\"if\",\"user-agent\",\"shared/ui/feature-header\",\"t\",\"address-banner\",\"shared/platform-notice\",\"shared/card\",\"section\",\"subscription-overview\",\"cancelled-plan-overview\",\"or\",\"link-to\",\"on\",\"monthly-post-usage\",\"credit-usage\",\"shared/badge\",\"perform\",\"concat\",\"and\",\"each\",\"-track-array\",\"shared/profile-avatar\",\"shared/ui/checkbox-switch\",\"action\",\"not\",\"billing-section\",\"shared/ui/button\",\"component\",\"-outlet\"]]",
    "moduleName": "settings/templates/overview.hbs",
    "isStrictMode": false
  });

  _exports.default = _default;
});